import { UseQueryResult, useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { auth } from '@olo-web/utils/google/firebase';

type GetUserByUidParams = {
  uid: string;
  merchantId?: string;
};

export const getUserByUid = async ({
  uid,
  merchantId,
}: GetUserByUidParams): Promise<IThemeUserRecord> => {
  try {
    const idToken = await auth().currentUser.getIdToken();
    const { data } = await axios.post(
      `/api/users/get-by-uid`,
      { uid, merchantId },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? error?.message);
  }
};

export const useGetUserByUid = (
  uid: string,
  merchantId?: string
): UseQueryResult<IThemeUserRecord, AxiosError> => {
  return useQuery(['theme-auth-user', uid, merchantId], () => getUserByUid({ uid, merchantId }), {
    staleTime: 100000,
    enabled: !!uid,
    retry: 0,
  });
};
